/**
 * TanStack Query hooks for `audit-trail-security-compliance-log`.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	auditTrailSecurityComplianceLogQueryKeys,
	type CreateAuditTrailBody,
	type ListAuditTrailParams,
	type ListAuditTrailResponse,
} from "./api";

export function useAuditTrailSecurityComplianceLogList(
	params: ListAuditTrailParams = {},
): UseQueryResult<ListAuditTrailResponse, Error> {
	return useQuery({
		queryKey: auditTrailSecurityComplianceLogQueryKeys.list(params),
		queryFn: () => list(params),
	});
}

export function useAuditTrailSecurityComplianceLogCreate(): UseMutationResult<
	{ ok: boolean; id: string; event_id: string; created_at: number },
	Error,
	CreateAuditTrailBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: auditTrailSecurityComplianceLogQueryKeys.all });
		},
	});
}
